import { useContext, useEffect, useState } from "react";

import classes from "./CabinetIngredientBar.module.css";

import CustomButton from "../../General_Elements/CustomButton/CustomButton";

import CartContext from "../../../store/cart-context";
import CabinetContext from "../../../store/cabinet-context";

// component representing each ingredient in cabinet
const CabinetIngredientBar = (props) => {
  const cartCtx = useContext(CartContext);
  const cabinetCtx = useContext(CabinetContext);

  const [removeIngredientView, setRemoveIngredientView] = useState(true);
  const [sufficientVolume, setSufficientVolume] = useState(true);

  // If the ingredient is in cart, will check if cabinet volume > cart volume
  let cartVolume;

  if (cartCtx.ingredients && cartCtx.ingredients[props.title]) {
    cartVolume = cartCtx.ingredients[props.title].volume;
  } else {
    cartVolume = 0;
  }

  // toggle option to remove ingredient from cabinet
  const toggleRemoveIngredientView = () => {
    setRemoveIngredientView(!removeIngredientView);
  };

  // remove ingredient from cabinet
  const removeIngredientHandler = () => {
    cabinetCtx.removeItem(props.id);
  };

  // will use this calculation for highlighting the ingredient icon green or red
  useEffect(() => {
    if (props.volume >= cartVolume) {
      setSufficientVolume(true);
    } else {
      setSufficientVolume(false);
    }
  }, [cartVolume, props.volume]);

  return (
    <div
      className={classes.cabinet_ingredient_bar}
      onClick={toggleRemoveIngredientView}
    >
      <img
        className={classes.image}
        src={props.image}
        alt="new"
        style={{
          border: "3px solid green",
          borderRadius: "15px",
          borderColor: sufficientVolume ? "#68bb59" : "#e85a4f",
        }}
      />
      <div className={classes.title}>{props.title}</div>

      {removeIngredientView ? (
        <div className={classes.volume}>
          {props.volume}
          {props.unit}
        </div>
      ) : (
        <CustomButton onClick={removeIngredientHandler} content={"-"} type={"minusButton"} width="50px" height="50px"/>
      )}
    </div>
  );
};

export default CabinetIngredientBar;
